var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarSeat = function SvgCarSeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 400,
    height: 400,
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.383 55.699 39.806 60 35 35.972V15a5 5 0 0 0-5-5h-.194L20 11.961 31.607 70H40v15H30v5h45v-5H65V70h15v-9.339a5 5 0 0 0-5.617-4.962ZM60 85H45V70h15v15Z"
  })));
};
export default SvgCarSeat;